import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { get } from '@eika-infrastruktur/request';

import { KREDITTBANKEN_BASE_URL } from '@/react-query/common';
import { isValidAccountNumber } from '@/utils/account-utils';

const checkAccountNumber = (accountNumber: string) => get<boolean>(`${KREDITTBANKEN_BASE_URL}/kar/${accountNumber}`);

export const useVerifyAccountOwner = (
    accountNumber: string,
    options?: Omit<UseQueryOptions<boolean>, 'queryKey' | 'queryFn'>,
) => {
    return useQuery<boolean>({
        queryKey: ['v4', 'kar', accountNumber],
        queryFn: () => checkAccountNumber(accountNumber),
        ...options,
        enabled: isValidAccountNumber(accountNumber) && (options?.enabled ?? true),
    });
};
